import { createServerRunner } from '@aws-amplify/adapter-nextjs';

const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.USER_POOL_ID,
      userPoolClientId: process.env.USER_POOL_CLIENT_ID,
      loginWith: {
        oauth: {
          domain: process.env.IDP_DOMAIN,
          scopes: ['email', 'openid'],
          responseType: 'code',
          redirectSignIn: [process.env.NEXT_PUBLIC_REDIRECT_SIGN_IN || 'https://dev.centralvaluations.ie/'],
          redirectSignOut: [process.env.NEXT_PUBLIC_REDIRECT_SIGN_OUT || 'https://dev.centralvaluations.ie/'],
        },
      },
    },
  },
};

export const { runWithAmplifyServerContext } = createServerRunner({
  config: amplifyConfig,
});

export { amplifyConfig };
